var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"tag",class:_vm.goal_tracking_tag_view_model.tag.class_name},[_vm._v(" "+_vm._s(_vm.goal_tracking_tag_view_model.tag.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }